import { FeedPageType } from "./feed";
import { BasePageType } from "./base";
import { EventsPageType } from "./events";
import { CommunityPageType } from "./community";
import { ProfilePageType } from "./profile";
import { SearchPageType } from "./search";
import { ProductsPageType } from "./product";
// Registry of all available page types
export const PageTypes = {
	feed: FeedPageType,
	events: EventsPageType,
	community: CommunityPageType,
	profile: ProfilePageType,
	search: SearchPageType,
	products: ProductsPageType,
	// Add other page types here as they're created
	// search: SearchPageType,
};

// Helper functions
export const getPageType = (type) => {
	return PageTypes[type.toLowerCase()] || null;
};

export const getDefaultContent = (type) => {
	const pageType = getPageType(type);
	return pageType ? pageType.getDefaultContent() : BasePageType.getDefaultContent();
};

export const getPageIcon = (type) => {
	const pageType = getPageType(type);
	return pageType ? pageType.icon : "document-outline";
};

export const getAvailablePageTypes = () => {
	return Object.entries(PageTypes).map(([key, pageType]) => ({
		type: key,
		title: pageType.title,
		icon: pageType.icon,
	}));
};

export default PageTypes;
